// Живой список локаций из биллинга: включил или выключил датацентр в админке —
// локация появилась или пропала на сайте. Ответ кэшируется в sessionStorage на
// 60 секунд, поэтому переходы по страницам не дёргают панель.
//
// Отказоустойчивость: прячем страну ТОЛЬКО если панель прямо сказала, что она
// выключена. Панель недоступна, ответ пустой или страны в нём нет — показываем
// как раньше. Сломать сайт этот код не может.
import { useEffect, useState } from 'react';
// Слепок состояния датацентров на момент сборки: нужен, чтобы пререндер
// (react-snap) сразу отдавал правильный список, а не показывал выключенную
// страну до загрузки JS. Обновляется автоматически при каждой сборке.
import dcStatus from './dcStatus.json';

const API = 'https://billing.netgrid.host/api/v1/public/locations';
const KEY = 'ng-locations-v1';
const TTL_MS = 60 * 1000;

const readCache = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !Array.isArray(obj.disabled)) return null;
    return obj;
  } catch (e) {
    return null;
  }
};

const fresh = (obj) => obj && typeof obj.ts === 'number' && Date.now() - obj.ts < TTL_MS;

// Коды стран, выключенных в админке. null = данных нет, ничего не прячем.
export const useDisabledLocationCodes = () => {
  const cached = readCache();
  const [codes, setCodes] = useState(
    cached ? cached.disabled : (Array.isArray(dcStatus.disabled) ? dcStatus.disabled : null)
  );

  useEffect(() => {
    if (fresh(cached)) return;
    let alive = true;
    fetch(API, { credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive || !d || !Array.isArray(d.codes_disabled)) return;
        const disabled = d.codes_disabled.map((c) => String(c).toLowerCase());
        setCodes(disabled);
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), disabled }));
        } catch (e) {
          /* приватный режим — просто живём без кэша */
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return codes;
};

// Код страны берём из пути к флагу: "/flags/nl.svg" -> "nl".
export const codeOf = (loc) => {
  const m = /\/flags\/([a-z]{2})\.svg/i.exec((loc && loc.flag) || '');
  return m ? m[1].toLowerCase() : '';
};
